import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Hem from "./pages/Hem";
import Tjanster from "./pages/Tjanster";
import Tillstand from "./pages/Tillstand";
import OmOss from "./pages/OmOss";
import Kontakt from "./pages/Kontakt";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main data-testid="main-content">
          <Routes>
            <Route path="/" element={<Hem />} />
            <Route path="/tjanster" element={<Tjanster />} />
            <Route path="/tillstand" element={<Tillstand />} />
            <Route path="/om-oss" element={<OmOss />} />
            <Route path="/kontakt" element={<Kontakt />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
